import { Collapse, Checkbox } from "antd";
import styled from "@emotion/styled";
import styles from "./index.module.scss";

type optionType = {
  value: any;
  label: any;
};

type propsType = {
  options?: optionType[];
  label?: string;
  value?: any;
  onChange?: any;
  children?: any;
};

const CollapseSingleSelect = ({
  options = [],
  label = "Label",
  value = [],
  onChange = () => {},
  children
}: propsType) => {
  const collapseChildren = (
    <CheckBoxStyled>
      <Checkbox.Group options={options} value={value} onChange={onChange}></Checkbox.Group>
    </CheckBoxStyled>
  );

  const extra = value.length ? (
    <CountStyled>{value.length ? value.length : null}</CountStyled>
  ) : null;

  const items = [
    {
      key: "1",
      label: <LabelStyled>{label}</LabelStyled>,
      children: children ? children : collapseChildren,
      extra: extra
    }
  ];

  return (
    <div className={styles.collapse_warp}>
      <Collapse
        bordered={false}
        expandIcon={() => <ArrowIcon />}
        expandIconPosition={"end"}
        ghost={true}
        items={items}
      />
    </div>
  );
};

const LabelStyled = styled.span`
  color: #111212;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 23px; /* 143.75% */
`;

const CountStyled = styled.span`
  border-radius: 10px;
  background: #1c70ee;
  display: flex;
  padding: 2px 6px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: #fff;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 15px; /* 125% */
  letter-spacing: 0.09px;
`;

const CheckBoxStyled = styled.div`
  div.ant-checkbox-group {
    display: flex;
    gap: 8px;

    > label.ant-checkbox-wrapper {
      border-radius: 8px;
      border: 1.2px solid #ebeef0;
      display: flex;
      padding: 6px 10px;
      justify-content: center;
      align-items: center;

      > span:first-of-type {
        display: none;
      }

      > span:last-child {
        padding: 0;
        color: #3b3c3c;
        font-size: 14px;
        font-style: normal;
        font-weight: 500;
        line-height: 24px;
      }
    }

    > label.ant-checkbox-wrapper-checked {
      border: 1.2px solid #1c70ee;

      > span:last-child {
        color: #1c70ee;
      }
    }
  }
`;

const ArrowIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='16' height='17' viewBox='0 0 16 17' fill='none'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M7.85396 7.18864L3.53415 11.5085C3.2738 11.7688 2.85169 11.7688 2.59134 11.5085L2.44992 11.367C2.18957 11.1067 2.18957 10.6846 2.44992 10.4242L7.85396 5.02018L13.258 10.4242C13.5184 10.6846 13.5184 11.1067 13.258 11.367L13.1166 11.5085C12.8562 11.7688 12.4341 11.7688 12.1738 11.5085L7.85396 7.18864Z'
      fill='black'
    />
  </svg>
);

export default CollapseSingleSelect;
